export const POPULAR_BRANDS = [
  // Dexcom Systems
  "Dexcom G7: Sensor",
  "Dexcom G7: Receiver",
  "Dexcom G6: Twin Pack",
  "Dexcom G6: Transmitter",
  "Dexcom Sensors: 3-Pack",
  "Dexcom Sensors: 1-Pack",
  "Dexcom Receiver: 1-Pack",
  "Dexcom Transmitter Kit",
  "Dexcom Transmitter: Small Box",
  // FreeStyle Libre
  "Libre 3: Sensor",
  "Libre 3: Reader",
  "Libre 3 Plus: Sensor",
  "Libre 3 Plus: Sensor (NFR)",
  "Libre 2: Sensor",
  "Libre 2: Reader",
  "Libre 14-Day: Sensor",
  "Libre 14-Day: Reader",
  // Omnipod Systems
  "Omnipod 5 (G6): 10-pack (Purple Box)",
  "Omnipod 5 (G6): Intro Kit (Purple Box)",
  "Omnipod 5: Controller PDM (1-pack)",
  "Omnipod: 1-pack (1005E)",
  "Omnipod DASH: 5-pack",
  "Omnipod DASH: 10-pack",
  "Omnipod DASH: PDM (1-pack)",
  "Omnipod Classic: 5-pack",
  "Omnipod Classic: 10-pack",
  "Omnipod Classic: PDM",
  "Omnipod 5 (G6)",
  "Omnipod G6: 5-Pack",
  "Omnipod G6: Pack Libre",
  "Omnipod G6: 5-Pack Medical",
  // Medtronic Systems
  "Medtronic: Advanced MMT-242A",
  "Medtronic: 780G Pump System",
  "Medtronic MiniMed: Pump",
  "Medtronic Guardian 4: MMT-784QK",
  "Medtronic Guardian 4: Transmitter Kit",
  "Medtronic MiniMed: Mio Advanced",
  "Medtronic Quick-Set: Pack of 10",
  "Medtronic Guardian Sensor: 5-Pack",
  "Medtronic Guardian Sensor (Single/General)",
  "Medtronic Reservoirs: Box of 10",
  // Tandem Diabetes Care
  "Tandem Autosoft XC",
  "Tandem Autosoft",
  "Tandem Autosoft 90",
  "Tandem t:slim",
  // Insulin & Injectables
  "Humulin Vials: N",
  "Humulin Vials: R",
  "Humulin Vials: 70/30",
  "Novolin: All kinds",
  "BD Needles",
  "Lancets",
  "Vials (General)",
  // Test Strips
  "Accu-Chek",
  "FreeStyle",
  "OneTouch",
  "Contour",
  "Dexcom Test Strips",
  "True Metrix",
  "ReliOn",
  "Embrace",
  "Other"
];

export const SERVICE_AREAS = [
  "Jacksonville",
  "Jacksonville Beach",
  "Orange Park",
  "Green Cove Springs",
  "Clay County",
  "St. Augustine",
  "Fernandina Beach",
  "Amelia Island",
  "Yulee"
];
